import {combineReducers} from "redux";

import appsetup from "../features/admin/customizations/appsetup/Slice";

import common from "../features/admin/common/Slice";

const customizations = combineReducers({
    appsetup,
    common
});

export default customizations;